import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { type AddOnModalStore } from 'pages/settings/ui/AddOnModal/store/addOnModalStore'
import styles from './styles.module.scss'

type IModalFirstStepActionsProps = {
  store: AddOnModalStore
}

export const ModalFirstStepActions = observer(({ store }: IModalFirstStepActionsProps) => {
  const getButtonText = () => {
    if (store.stepsCount === 2) {
      return 'Continue'
    }
    return store.isActive ? 'Go to settings' : 'Register'
  }
  return (
    <div className={styles.firstStepActions}>
      <Typography
        ariaLabel='RegistrationRequired'
        variant='body-sm-regular'
        color='var(--content-primary-tertiary)'
        tag='div'
        className={styles.registrationRequired}
      >
        Registration is required
      </Typography>

      <Button
        text='Cancel'
        onClick={store.closeGetAddOnModal}
        typeBtn={'contained'}
        size={'medium'}
        contained={'secondary'}
      />
      <Button
        text={getButtonText()}
        onClick={store.stepsCount === 1 ? store.registerAction : store.firstStepAction}
        typeBtn={'contained'}
      />
    </div>
  )
})
